module.exports = __webpack_public_path__ + "6a9ea54d189e901b7820176dddbf3678.jpg";